import React, { useCallback, useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  DropdownMenu,
  FormFieldSet,
  InfoCircle,
  LogoLoader,
  Modal,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { usePagination } from "../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { getCompaniesStart } from "../../../../redux/slices/accountDetails/accountDetailsSlice";
import { Link } from "react-router-dom";
import EditModal from "./Modals/EditModal";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";

const AllAccounts = () => {
  const [showDataId, setShowDataId] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [composeModal, setComposeModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const whatsappIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="14"
      height="14"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="WhatsApp"
    >
      <title>WhatsApp</title>

      <path
        fill="#25D366"
        d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 .02 5.35.02 12c0 2.11.55 4.08 1.6 5.83L0 24l6.42-1.68A11.94 11.94 0 0 0 12 24c6.63 0 12-5.35 12-12 0-3.2-1.25-6.2-3.48-8.32z"
      />

      <path
        fill="#FFFFFF"
        d="M17.56 14.01c-.3-.15-1.76-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.95 1.15-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.48-.9-.8-1.51-1.78-1.69-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.2.05-.37-.03-.52-.08-.15-.67-1.6-.92-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48 1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.48 2.98 1.29 2.98.86 3.52.81.54-.05 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.08-.13-.27-.2-.57-.35z"
      />
    </svg>
  );
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.auth);
  const { companies } = useSelector((state) => state?.accountDetails);
  const { loading } = useSelector((state) => state?.accountDetails);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const value = companies?.[0]?.total ?? 0;
  const totalCount = value || 0;
  // const STATUS_MAP = {
  //   1: "Active",
  //   2: "Inactive",
  //   3: "Blocked",
  //   4: "DNC",
  // };
  const STATUS_MAP = {
    1: "Active",
    2: "Blocked",
  };
  const columns = [
    {
      key: "icons",
      value: "",
      width: "min-w-[300px]! max-w-[350px]!",
      render: (row) => {
        const phoneEmpty = row?.phone > 0;
        return (
          <div className="flex items-center gap-2">
            <div>
              <DropdownMenu
                MenuSection={
                  <div className="flex flex-col">
                    <Button
                      title={"Edit"}
                      icon={"edit_square"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      onClick={() => {
                        setSelectedCompany(row);
                        setOpenEditModal(true);
                      }}
                    />
                    <Button
                      title={"Compose Mail"}
                      icon={"mail"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      onClick={() => setComposeModal(true)}
                    />
                  </div>
                }
              >
                <Button
                  icon={"more_vert"}
                  variant="text"
                  type="icon"
                  size="xs"
                  color="black"
                />
              </DropdownMenu>
            </div>
            <div>
              <Button
                type="icon"
                icon={"contacts"}
                variant="text"
                color={phoneEmpty ? "success" : "gray-300"}
              />
            </div>
            <div>
              {/* {row.contacts > 0 && (
                <SmartTooltip description="Contacts" noicon>
                  <InfoCircle
                    color="primary"
                    colorDepth="500"
                    className="text-white"
                    value={row.contacts}
                    prefix={"+"}
                    noBorder
                    size="xs"
                  />
                </SmartTooltip>
              )} */}
              <SmartTooltip description="Contacts" noicon>
                <InfoCircle
                  color="primary"
                  colorDepth="500"
                  className="text-white"
                  value={row?.prospectCount || 0}
                  prefix={row?.prospectCount > 0 ? "+" : "-"}
                  noBorder
                  size="xs"
                />
              </SmartTooltip>
            </div>
            <div>
              <SmartTooltip description="Oppurtunities" noicon>
                <InfoCircle
                  color="invoiced"
                  colorDepth="100"
                  className="text-white"
                  value={row?.opportunities}
                  prefix={row?.opportunities > 0 ? "+" : "-"}
                  noBorder
                  size="xs"
                />
              </SmartTooltip>
            </div>
            <div>
              <SmartTooltip description="Jobs" noicon>
                <InfoCircle
                  color="danger"
                  colorDepth="500"
                  className="text-white"
                  value={row?.jobsCount}
                  prefix={row?.jobsCount > 0 ? "+" : "-"}
                  noBorder
                  size="xs"
                />
              </SmartTooltip>
            </div>
            <div>
              <SmartTooltip description="Placements" noicon>
                <InfoCircle
                  color="gray"
                  colorDepth="700"
                  className="text-white"
                  value={row?.placements}
                  prefix={row?.placements > 0 ? "+" : "-"}
                  noBorder
                  size="xs"
                />
              </SmartTooltip>
            </div>
            <div>
              <SmartTooltip description="Agreements" noicon>
                <InfoCircle
                  color="info"
                  colorDepth="500"
                  className="text-white"
                  value={row?.agreement}
                  prefix={row?.agreement > 0 ? "+" : "-"}
                  noBorder
                  size="xs"
                />
              </SmartTooltip>
            </div>
          </div>
        );
      },
    },
    {
      key: "companyName",
      label: "Client Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row?.name)}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <Link
            to={`/ats/all-account-details`}
            className="text-info"
            state={{ uiid: row?.uiid }}
            onClick={() =>
              sessionStorage.setItem("selectedCompanyUiid", row?.uiid)
            }
          >
            <span className="line-clamp-1!">{formatWords2(row?.name)}</span>
          </Link>
        </SmartTooltip>
        // <Link to={`/ats/all-account-details/${row.uiid}`} className="text-info">
        //   {row.name}
        // </Link>
      ),
    },
    {
      key: "contactNumber",
      label: "Contact Number",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <div className="flex items-center">
          {row.contactNumber !== "-" && (
            <SmartTooltip description={"Phone"} noicon>
              <Button
                type="icon"
                variant="text"
                color="black"
                size="sm"
                icon={"phone_in_talk"}
              />
            </SmartTooltip>
          )}
          {row?.contactNumber}
          {row?.contactNumber !== "-" && (
            <SmartTooltip description={"text"} noicon>
              <Button
                type="icon"
                variant="text"
                color="black"
                icon={"chat"}
                size="sm"
              />
            </SmartTooltip>
          )}
          {row?.contactNumber !== "-" && (
            <SmartTooltip description={"Whatsapp"} noicon>
              <Button
                type="icon"
                variant="text"
                color="black"
                icon={whatsappIcon}
              />
            </SmartTooltip>
          )}
        </div>
      ),
    },
    {
      key: "website",
      label: "Website",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.website}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <span className="line-clamp-1!">{row?.website}</span>
        </SmartTooltip>
      ),
    },
    {
      key: "industry",
      label: "Industry",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.industry}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <span>{formatWords2(row?.industry || "")}</span>
        </SmartTooltip>
      ),
    },
    {
      key: "status",
      label: "Status",
      width: "min-w-[150px]! max-w-[200px]!",
      // render: (row) => STATUS_MAP[row?.status] || "-",
      render: (row) => (
        // <Chip
        //   label={STATUS_MAP[row?.status] || "-"}
        //   color="success"
        //   className="py-2 px-3 text-success"
        // />
        <StatusTags tag={STATUS_MAP[row?.status] || "-"} />
      ),
    },
    {
      key: "createdBy",
      label: "Created By",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => formatWords2(row?.addedBy?.firstName || "-"),
    },
    // {
    //   key: "createdOn",
    //   label: "Created On",
    //   render: (row) => {
    //     return (
    //       <div>
    //         {dateFormator(row.addedOn, "datetime-ampm")}{" "}
    //         {dateFormator(row.addedOn, "timeZone")}
    //       </div>
    //     );
    //   },
    // },
    {
      key: "addedOn",
      label: "Created On",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={dateFormator(
            convertFromUTC(row?.addedOn),
            "datetime-ampm",
          )}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {dateFormator(convertFromUTC(row?.addedOn), "datetime-ampm")}{" "}
          </div>
        </SmartTooltip>
      ),
    },

    {
      key: "modifiedOn",
      label: "Modified On",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={convertFromUTC(row?.modified?.on)}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {convertFromUTC(row?.modified?.on)}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "modifiedBy",
      label: "Modified By",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(
            row?.modified?.by?.firstName || row?.modified?.by || "",
          )}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {formatWords2(
              row?.modified?.by?.firstName || row?.modified?.by || "",
            )}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "country",
      label: "Country",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row?.latestJobLocation?.country || "")}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {formatWords2(row?.latestJobLocation?.country || "")}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "state",
      label: "State",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row?.latestJobLocation?.state || "")}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {formatWords2(row?.latestJobLocation?.state || "")}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "city",
      label: "City",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row?.latestJobLocation?.city || "")}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {formatWords2(row?.latestJobLocation?.city || "")}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "zip",
      label: "Zip",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row?.latestJobLocation?.zip || "")}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {formatWords2(row?.latestJobLocation?.zip || "")}
          </div>
        </SmartTooltip>
      ),
    },
  ];

  const industryList = ["Career Builder", "Monster"];
  const statusList = ["Active", "Inactive"];
  const createdByList = ["Sajida", "Ambika", "Kranthi"];
  const randomMongoDate = (start, end) => {
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();
    const randomTime = startTime + Math.random() * (endTime - startTime);
    return new Date(randomTime);
  };

  const rows = Array.from({ length: 162 }, (_, i) => ({
    id: i + 100,
    icons: "",
    companyName: `Company ${i + 1}`,
    phone: Math.floor(Math.random() * 6),
    contacts: Math.floor(Math.random() * 10),
    oppurtunities: Math.floor(Math.random() * 8),
    jobs: Math.floor(Math.random() * 6),
    placements: Math.floor(Math.random() * 4),
    agreements: Math.floor(Math.random() * 2),
    contactNumber: `+1 (${Math.floor(Math.random() * 1000)}) ${Math.floor(
      Math.random() * 1000,
    )}-${Math.floor(Math.random() * 10000)}`,
    website: `https://www.company${i + 1}.com`,
    industry: industryList[Math.floor(Math.random() * industryList.length)],
    status: statusList[Math.floor(Math.random() * statusList.length)],
    createdBy: createdByList[Math.floor(Math.random() * createdByList.length)],
    createdOn: randomMongoDate(
      "2022-07-31T06:45:00-04:00", // July 31, 2022 02:45 AM EDT
      "2025-08-01T06:45:00-04:00", // Aug 1, 2025 02:45 AM EDT
    ),
    modifiedOn: "",
    modifiedBy: "",
    country: "USA",
    state: "California",
    city: "San Francisco",
    zip: "94102",
  }));

  // const mappedRows = mapTableRows(rows, columns);
  const mappedRows = mapTableRows(companies?.[0]?.data || companies, columns);
  const handleServerSearch = useCallback((key, val) => {
    setSearchTerm(val);
  }, []);

  // const rowData = rows.find((item) => item.id === showDataId);
  useEffect(() => {
    dispatch(
      getCompaniesStart({
        coll: "Company",
        lim: limit,
        pg: page,
        ret: "uiid name website industry addedBy addedOn status modified location",
        useAggregate: true,
        fil: {
          // uiid: { type: "AG_ALL_ACCOUNTS", value: "" },
          uiid: { type: "AG_ALL_ACCOUNTS", value: debouncedSearch || "" },
        },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
        ref: "AddedBy ModifiedBy",
      }),
    );
  }, [dispatch, page, limit, debouncedSearch]);
  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
      setPage(1); // reset to first page when searching
    }, 500);
    return () => clearTimeout(delay);
  }, [searchTerm]);
  return (
    <div className="flex flex-col mt-5 flex-1 overflow-hidden">
      {/* Table + Side Panel */}
      <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
        <div className="flex overflow-auto shadow-tableset">
          <TableAdv
            tableId={"bdmam_accounts_allaccounts"}
            columns={columns}
            showSlNo
            rows={mappedRows}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            // defaultSelectedRows={[showDataId]}
            serverSerchValue={searchTerm}
            serverOnSearch={handleServerSearch}
            defaultSelectedRows={showDataId ? [showDataId] : []}
            toolbarRight={{
              search: true,
              fullScreen: true,
              filter: false,
              download: false,
              // add: [
              //   {
              //     component: (
              //       <div className="flex gap-3">
              //         <div className="flex justify-end items-end">
              //           <Button
              //             title="Import from Excel"
              //             size="sm"
              //             icon={"download"}
              //             onClick={() => setShowUploadModal(true)}
              //           />
              //         </div>
              //       </div>
              //     ),
              //   },
              // ],
            }}
          />
        </div>
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <Modal
        isOpen={openEditModal}
        onClose={() => setOpenEditModal(false)}
        title={"Edit"}
        titleColor={"primary"}
        width="max-w-4xl"
      >
        <EditModal
          onCancel={() => setOpenEditModal(false)}
          companyData={{
            uiid: selectedCompany?.uiid || null,
            name: selectedCompany?.name || "-",
            location: selectedCompany?.location || {},
            website: selectedCompany?.website || "-",
            industry: selectedCompany?.industry || "-",
            addedOn: selectedCompany?.addedOn || null,
            status: selectedCompany?.status || null,
          }}
          onSuccess={() => {
            dispatch(
              getCompaniesStart({
                coll: "Company",
                lim: limit,
                pg: page,
                ret: "uiid name website industry addedBy addedOn status modified location",
                useAggregate: true,
                fil: {
                  // uiid: { type: "AG_ALL_ACCOUNTS", value: "" },
                  uiid: {
                    type: "AG_ALL_ACCOUNTS",
                    value: debouncedSearch || "",
                  },
                },
                extret: "uiid firstName",
                sort: { addedOn: -1 },
                ref: "AddedBy ModifiedBy",
              }),
            );
            setOpenEditModal(false);
            // fetchAccountDetails();
          }}
        />
      </Modal>
      <Modal
        isOpen={composeModal}
        onClose={() => setComposeModal(false)}
        width="max-w-4xl"
        title={"Compose"}
      >
        <div className="px-4 py-2">
          <div className="grid grid-cols-4 gap-6 ">
            <FormFieldSet
              type="select"
              placeholder="Select"
              title="Email Source"
              options={[
                { label: "Gmail", value: 1 },
                { label: "Outlook", value: 2 },
                { label: "Mailgun", value: 3 },
                { label: "AWS-SES", value: 4 },
              ]}
              // value={formData.emailSource}
              // onChange={(value) => handleChange("emailSource", value)}
              // error={errors.emailSource}
              shadow={true}
            />
            <FormFieldSet
              type="emailSourceAccounts"
              placeholder="Select Account"
              title="Email Account"
              // options={[
              //   { label: "brown@tektreeinc.com", value: "1" },
              //   { label: "aden@tektreeinc.com", value: "2" },
              // ]}
              // value={formData.emailAccount}
              // onChange={(value) => handleChange("emailAccount", value)}
              // error={errors.jobCode}
              // disabled={!formData.emailSource}
              // filters={{ category: 11, type: formData.emailSource }}
              // filters={{ employeeId: employeeProfileUiid }}
              shadow={true}
            />
            {/* <FormFieldSet
              type="select"
              placeholder="Select Email"
              title="Type of Email"
              options={[
                { label: "Latest Data", value: 1 },
                { label: "Follow-up Data", value: 2 },
              ]}
              // value={formData.typeOfEmail}
              // onChange={(value) => {
              //   handleChange("typeOfEmail", value);
              //   const selectedDate =
              //     value === 1 ? dayjs() : dayjs().subtract(1, "day");
              //   handleChange("date", selectedDate);
              //   fetchFollowAssignments(selectedDate);
              // }}
              // error={errors.typeOfEmail}
              shadow={true}
            />
            <FormFieldSet
              type="datepicker"
              placeholder="Select Account"
              title="Date Picker"
              //value={formData.date}
              // onChange={(value) => {
              //   handleChange("date", value);
              //   fetchFollowAssignments(value);
              // }}
              // error={errors.date}
              shadow={true}
            /> */}
            <FormFieldSet
              type="templates"
              placeholder="Select"
              title="Template"
              options={[
                { label: "Brown", value: "1" },
                { label: "Aden", value: "2" },
              ]}
              // value={formData.template}
              // onChange={(value) => {
              //   handleChange("template", value);
              //   handleGetTemplate(value?.value);
              // }}
              // error={errors.template}
              // disabled={!formData.emailAccount}
              // filters={{ userId: formData.emailAccount?.userId }}
              // filters={{ userId: 3 }}
              shadow={true}
            />
            <FormFieldSet
              placeholder="Subject"
              title="Subject"
              // value={formData.subject}
              // onChange={(value) => handleChange("subject", value)}
              // error={errors.subject}
              shadow={true}
            />
          </div>
          <div className="grid grid-cols-1 my-4 gap-6">
            <FormFieldSet
              type="textArea"
              title="Text Here"
              // value={formData.emailText}
              // onChange={(value) => handleChange("emailText", value)}
              // error={errors.emailText}
              rows={4}
              shadow={true}
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button
              title={"Cancel"}
              variant="outlined"
              onClick={() => setComposeModal(false)}
            />
            <Button
              title={"Save"}
              // onClick={()=>handleSendEmails()}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AllAccounts;
